//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export var VARIANTS = {
  ANCHOR: 'a',
  BUTTON: 'button'
};
export var TYPES = {
  DARK: 'dark',
  DARK_OUTLINE: 'dark-outline',
  LIGHT: 'light',
  LIGHT_OUTLINE: 'light-outline',
  TEXT: 'text'
};
export var SIZES = {
  SMALL: 'small',
  NORMAL: 'normal',
  MEDIUM: 'medium',
  LARGE: 'large'
};
export default {
  name: 'Button',
  props: {
    /**
     * HTML tag for the Button
     */
    variant: {
      type: String,
      default: VARIANTS.BUTTON,
      validator: function validator(value) {
        return Object.values(VARIANTS).includes(value);
      }
    },

    /**
     * Button Style
     */
    type: {
      type: String,
      default: TYPES.DARK,
      validator: function validator(value) {
        return Object.values(TYPES).includes(value);
      }
    },

    /**
     * Button Size
     */
    size: {
      type: String,
      default: SIZES.MEDIUM,
      validator: function validator(value) {
        return Object.values(SIZES).includes(value);
      }
    },

    /**
     * Disables Button
     */
    isDisabled: {
      type: Boolean,
      default: false
    },

    /**
     * Button would have look and feel as "isDisabled" but click events are not blocked
     */
    isInactive: {
      type: Boolean,
      default: false
    },

    /**
     * Submitting state
     */
    isSubmitting: {
      type: Boolean,
      default: false
    },

    /**
     * Redirect URL
     */
    url: {
      type: String,
      default: ''
    }
  },
  computed: {
    isDeactivated: function isDeactivated() {
      return this.isDisabled || this.isSubmitting;
    },
    href: function href() {
      return this.variant === VARIANTS.ANCHOR ? this.url : '';
    }
  }
};